<script>
  import { External, M } from '../../external';
  import { onMount } from 'svelte';
	import NoDataPlaceholder from "../../Common/NoDataPlaceholder.svelte";

  export let contact;

  const messages = {
    loading: true,
    data: [],
    pagination: {
      page: 0,
      nextPage: () => {
        messages.pagination.page += 1;
      },
      previousPage: () => {
        messages.pagination.page -= 1;
      },
      pagesCount: 0 // will be updated with every fetch
    },
    fetch: () => {
      messages.loading = true;
      External.Tools.makeWebsiteRequest({
        action: 'getFormMessages',
        data: {
          page: messages.pagination.page,
          contact: contact.data.id
        },
        onOk: function (result) {
          messages.data = result.data.items;
          messages.pagination.pagesCount = result.data.pagesCount;
          messages.loading = false;
        }
      });
    },
    markAsRead: (message) => {
      External.Tools.makeWebsiteRequest({
        action: 'markFormMessageAsRead',
        data: {
          id: message.id
        }
      });

      message.read = true;
    }
  };

  const getName = (message) => {
    let name = message.customerName;
    if (!name) {
      const regexp = /<h4>(.*?)<\/h4><span>(.*?)<\/span>/g;
      let match;
      match = regexp.exec(message.message);
      name = match[2];
    }

    if (message.form) {
      name = (name ? name + ' - ' : '') + message.form;
    }

    return External.Tools.escapeIfNeeded(name ? name : '-');
  };

  const getEmail = (message) => {
    let email = message.customerEmail;
    if (!email) {
      const regexp = /<h4>(.*?)<\/h4><span>(.*?)<\/span>/g;
      const match = regexp.exec(message.message);
      const value = match[2];
      if (value.indexOf('@') > 0) {
        email = value;
      }
    }

    return email ? email : '-';
  };

  const getTime = (message) => {
    return External.Tools.dateToString(new Date(message.received), true);
  };

  onMount(() => {
    messages.fetch();
  });
</script>

<div class="col20 f-left" data-role="messages">
  {#if messages.loading}
    <div class="small-centered-loading-icon"></div>
  {:else}
    <div class:none={!messages.loading} class="text-center">
      <i class="fa fa-circle-o-notch fa-spin" style="font-size: 30px;"></i>
    </div>
    <ul class="messages-wrapper col20 f-left">
      {#if !messages.loading && messages.data.length === 0}
				<div class="col20 f-left t-center mb-15">
					<NoDataPlaceholder message={M.THERE_ARE_NO_MESSAGES} />
				</div>
      {:else if !messages.loading}
        {#each messages.data as message}
          <li
            class:not-read={!message.read}
            class:active={message.active}
            on:click={() => {
              message.active = !message.active;
              messages.markAsRead(message);
            }}
            data-id={message.id}>
            <h5 class="message-name">{getName(message)}</h5>
            <h6 class="message-email">
              {getEmail(message)}
              <span class="message-info">
                <span class="f-right">{getTime(message)}</span>
              </span>
            </h6>
            <div class="col20 f-left message-content">
              <div class="message-wrapper-outer">
                <div class="message-wrapper-content">{@html message.message}</div>
              </div>
            </div>
          </li>
        {/each}
      {/if}
    </ul>
    <div class="table-nav mt-25">
      <a
        class:none={messages.pagination.page < 1}
        class="f-left"
        on:click={() => {
          messages.pagination.previousPage();
          messages.fetch();
        }}
        data-action="prevMessagePage"
        rel="action">{M.PREV_PAGE}</a>
      <a
        class:none={messages.pagination.page >= messages.pagination.pagesCount - 1}
        class="f-right"
        on:click={() => {
          messages.pagination.nextPage();
          messages.fetch();
        }}
        data-action="nextMessagePage"
        rel="action">{M.NEXT_PAGE}</a>
    </div>
  {/if}
</div>
